"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var InputGroup_1 = __importDefault(require("../ui-components/InputGroup"));
var Credentials = function (_a) {
    var credentials = _a.credentials;
    return (preact_1.h("section", null,
        preact_1.h(InputGroup_1.default, { title: 'Client ID', value: credentials.id, disabled: true }),
        preact_1.h(InputGroup_1.default, { title: 'Client secret', value: credentials.secret, disabled: true }),
        preact_1.h("div", { className: 'alert alert-warning' },
            preact_1.h("p", null, "Make sure you copy and store your Client ID and Client Secret - we won\u2019t show them again after you leave this page."),
            preact_1.h("p", null, "Take care to keep your client credentials secure."),
            preact_1.h("p", null, "Publicly exposing your credentials can result in your account being compromised, which could lead to unexpected/malicious behaviour on your community."))));
};
exports.default = Credentials;
